<template>
	<div v-if="body_show">
		<div class="task_box">
      <div>


        <div v-for="(item, index) in dynamicData" :class="(item.config && typeof item.config.isBlock === 'boolean') ? (item.config.isBlock ? 'block' : 'inBlock') : 'block'">
          <!-- 任务标题 -->
          <div v-if="item.type === 'taskTitle'" class="task-title row-margin" :style="{'color': item.style.color.hex}">
            {{ item.value }}
          </div>
          <!-- 行标题 -->
          <div v-if="item.type === 'titleType'" class="task_rows  row-margin">
            <div>
              <span v-for="el in item.list" @click="showTagModul(el.open, el.openContent)" :class="el.sizeLg ? 'max' : 'min'" :style="{'color': el.style.color.hex, 'text-decoration': el.style.underline}">{{el.value}}</span>
            </div>
          </div>
          <!-- 分割线 -->
          <div v-if="item.type === 'lineAcross'" class="row-margin">
            <div :style="{'borderBottom': '1px solid #000', 'borderColor': item.style.color.hex}"></div>
          </div>
          <!-- 空白行 间隔 -->
          <div v-if="item.type === 'lineAcross'" class="row-margin">
            <div :style="{'height': item.style.height + 'px', 'width': '100%'}"></div>
          </div>
          <!-- 链接 -->
          <div v-if="item.type === 'routerLink'" class="row-margin">
            <div>
              <router-link class="task-link" tag="div" :style="{'color': item.style.color.hex, 'text-decoration': item.style.underline}" :to="`/${item.link.split('/').pop()}`">
                <img src="../../../assets/hxz.png" />
                {{item.value}}
              </router-link>
            </div>
          </div>
          <!-- 文字带输入组 -->
          <div v-if="item.type === 'fillType'" class="row-margin">
            <div class="fill-box">
              <div v-for="el in item.list">
                <!-- 文本 -->
                <span v-if="el.type === 'label'" :style="{'color': el.style.color.hex, 'text-decoration': el.style.underline}">{{el.value}}</span>
                <!-- 下划线输入组 -->
                <input v-if="el.type === 'lineInput'" type="text" v-model="el.value" class="line-input" />
                <!-- 边框输入组 -->
                <input v-if="el.type === 'frameInput'" v-model="el.value" type="text" class="frame-input" />
                <!--  -->
              </div>
            </div>
          </div>
          <!-- 图片上传 -->
          <div v-if="item.type === 'updateImg'" class="row-margin">
            <div>
              <div class="upload-img clearfix">
                <a @click.prevent="uploadImgHandle(item)">
                  <img :src="item.value || imgSrc" />
                </a>
                <p :style="{'color': item.style.color.hex}">{{item.label}}</p>
              </div>
            </div>
          </div>
          <!-- 单选按钮 -->
          <div v-if="item.type === 'radioBtn'" class="row-margin">
            <div class="clearfix row-button">
              <button v-for="el in item.list" @click="setChunkIndex(item, el)" :style="{'border': '1px solid #000', 'borderColor': item.style.color.hex, 'color': !(item.value === el) ? item.style.color.hex : '#fff', 'background': (item.value === el) ? item.style.color.hex : '#ffffff'}">{{el}}</button>
            </div>
          </div>
          <!-- 单行输入组 -->
          <div v-if="item.type === 'textInput'" class="row-margin">
            <div class="pr row-input public-input">
              <input v-model="item.value" type="text" @input="changeVal($event, item, item.config.maxLength)" :placeholder="item.config.placeholder" />
              <span class="pa tip-num">{{item.value.length}}/{{item.config.maxLength}}</span>
            </div>
          </div>
          <!-- 多行输入组 -->
          <div v-if="item.type === 'textArea'" class="row-margin">
            <div class="pr textArea public-input">
              <textarea v-model="item.value" @input="changeVal($event, item, item.config.maxLength)" :placeholder="item.config.placeholder"></textarea>
              <span class="pa tip-num">{{item.value.length}}/{{item.config.maxLength}}</span>
            </div>
          </div>
          <!-- 省市下拉 -->
          <div v-if="item.type === 'selectPos'" class="row-margin">
            <div class="input-box">
              <van-cell-group class="task-dynamic-cell-group">
                <van-field placeholder="省/直辖市" v-model="item.value" @click="showLocalSelect(item)" readonly />
                <label class="choose_lable"></label>
              </van-cell-group>
            </div>
          </div>
          <!-- 单选下拉 -->
          <div v-if="item.type === 'selectOne'" class="row-margin selectOne">
            <div class="input-box">
              <van-cell-group class="task-dynamic-cell-group">
                <van-field v-model="item.value" @click="showPickerSelect(item)" readonly />
                <label class="choose_lable"></label>
              </van-cell-group>
            </div>
          </div>
          <!-- 双选下拉 -->
          <div v-if="item.type === 'selectTwo'" class="row-margin">
            <div class="input-box">
              <van-cell-group class="task-dynamic-cell-group">
                <van-field placeholder=""  v-model="item.value" @click="showSelectTwoPicker(item)" readonly />
                <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
              </van-cell-group>
            </div>
          </div>
          <!-- 级联下拉 A B -->
          <div v-if="item.type === 'selectApi1' || item.type === 'selectApi2'" class="row-margin">
            <div class="input-box">
              <van-cell-group class="task-dynamic-cell-group">
                <van-field v-model="item.value" @click="showPickerSelect(item, true)" readonly />
                <label class="choose_lable"></label>
              </van-cell-group>
            </div>
          </div>
          <!-- copy类型 -->
          <div v-if="item.type === 'copyType'" class="row-margin">
            <div v-if="item.list.length">
              <div v-for="cf in item.list">
                <div v-for="(xs, index) in cf" :class="(xs.type === 'selectOne' && !xs.config.isBlock) ? 'inBlock' : 'block'">



                  <!-- 任务标题 -->
                  <div v-if="xs.type === 'taskTitle'" class="task-title row-margin" :style="{'color': xs.style.color.hex}">
                    {{ xs.value }}
                  </div>
                  <!-- 行标题 -->
                  <div v-if="xs.type === 'title'" class="task_rows row-margin">
                    <div>
                      <span v-for="el in xs.list" @click="showTagModul(el.open, el.openContent)" :class="el.sizeLg ? 'max' : 'min'" :style="{'color': el.style.color.hex, 'text-decoration': el.style.underline}">{{el.value}}</span>
                    </div>
                  </div>
                  <!-- 分割线 -->
                  <div v-if="xs.type === 'lineAcross'" class="row-margin">
                    <div :style="{'borderBottom': '1px solid #000', 'borderColor': xs.style.color.hex}"></div>
                  </div>
                  <!-- 空白行 间隔 -->
                  <div v-if="xs.type === 'lineAcross'" class="row-margin">
                    <div :style="{'height': xs.style.height + 'px', 'width': '100%'}"></div>
                  </div>
                  <!-- 链接 -->
                  <div v-if="xs.type === 'routerLink'" class="row-margin">
                    <div>
                      <router-link class="task-link" tag="div" :style="{'color': xs.style.color.hex, 'text-decoration': xs.style.underline}" :to="`/${xs.link.split('/').pop()}`">
                        <img src="../../../assets/hxz.png" >
                        {{xs.value}}
                      </router-link>
                    </div>
                  </div>
                  <!-- 文字带输入组 -->
                  <div v-if="xs.type === 'fillType'" class="row-margin">
                    <div class="fill-box">
                      <div v-for="el in xs.list">
                        <!-- 文本 -->
                        <span v-if="el.type === 'label'" :style="{'color': el.style.color.hex, 'text-decoration': el.style.underline}">{{el.value}}</span>
                        <!-- 下划线输入组 -->
                        <input v-if="el.type === 'lineInput'" type="text" v-model="el.value" class="line-input" />
                        <!-- 边框输入组 -->
                        <input v-if="el.type === 'frameInput'" v-model="el.value" type="text" class="frame-input" />
                        <!--  -->
                      </div>
                    </div>
                  </div>
                  <!-- 图片上传 -->
                  <div v-if="xs.type === 'updateImg'" class="row-margin">
                    <div>
                      <div class="upload-img clearfix">
                        <a @click.prevent="uploadImgHandle(xs)">
                          <img :src="xs.value || imgSrc" />
                        </a>
                        <p :style="{'color': xs.style.color.hex}">{{xs.label}}</p>
                      </div>
                    </div>
                  </div>
                  <!-- 单选按钮 -->
                  <div v-if="xs.type === 'radioBtn'" class="row-margin">
                    <div class="clearfix">
                      <button v-for="el in xs.list" @click="setChunkIndex(xs, el)" :style="{'border': '1px solid #000', 'borderColor': xs.style.color.hex, 'background': xs.value === el ? xs.style.color.hex : '#ffffff'}">{{el}}</button>
                    </div>
                  </div>
                  <!-- 单行输入组 -->
                  <div v-if="xs.type === 'textInput'" class="row-margin">
                    <div class="pr row-input public-input">
                      <input v-model="xs.value" type="text" @input="changeVal($event, xs, xs.config.maxLength)" :placeholder="xs.config.placeholder" />
                      <span class="pa tip-num">{{xs.value.length}}/{{xs.config.maxLength}}</span>
                    </div>
                  </div>
                  <!-- 多行输入组 -->
                  <div v-if="xs.type === 'textArea'" class="row-margin">
                    <div class="pr textArea public-input">
                      <textarea v-model="xs.value" @input="changeVal($event, xs, xs.config.maxLength)" :placeholder="xs.config.placeholder"></textarea>
                      <span class="pa tip-num">{{xs.value.length}}/{{xs.config.maxLength}}</span>
                    </div>
                  </div>
                  <!-- 省市下拉 -->
                  <div v-if="xs.type === 'selectPos'" class="row-margin">
                    <div class="input-box">
                      <van-cell-group class="task-dynamic-cell-group">
                        <van-field placeholder="省/直辖市" v-model="xs.value" @click="showLocalSelect(xs)" readonly />
                        <label class="choose_lable"></label>
                      </van-cell-group>
                    </div>
                  </div>
                  <!-- 单选下拉 -->
                  <div v-if="xs.type === 'selectOne'" class="row-margin">
                    <div class="input-box">
                      <van-cell-group class="task-dynamic-cell-group">
                        <van-field v-model="xs.value" :label="xs.config.isBlock ? '' : xs.label" @click="showPickerSelect(xs, false, true)" readonly />
                        <label class="choose_lable"></label>
                      </van-cell-group>
                    </div>
                  </div>
                  <!-- 双选下拉 -->
                  <div v-if="xs.type === 'selectTwo'" class="row-margin">
                    <div class="input-box">
                      <van-cell-group class="task-dynamic-cell-group">
                        <van-field placeholder=""  v-model="xs.value" @click="showSelectTwoPicker(xs, true)" readonly />
                        <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                      </van-cell-group>
                    </div>
                  </div>
                  <!-- 级联下拉 A B -->
                  <div v-if="xs.type === 'selectApi1' || xs.type === 'selectApi2'" class="row-margin">
                    <div class="input-box">
                      <van-cell-group class="task-dynamic-cell-group">
                        <van-field v-model="xs.value" @click="showPickerSelect(xs, true, true)" readonly />
                        <label class="choose_lable"></label>
                      </van-cell-group>
                    </div>
                  </div>



                </div>
              </div>
            </div>
            <div class="text-center row-margin">
              <van-icon :style="{color: '#aaa'}" @click="startCopyItem(item)" name="add-o" size="40px" />
              <p :style="{'color': item.style.color.hex}" class="text-center">{{item.label}}</p>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button @click="testDataCode" class="sub_button">提交</button>
        </div>
      </div>
    </div>
    <!-- 单选 selectOne -->
    <van-popup v-model="selectOne_picker" position="bottom">
      <van-picker show-toolbar :columns="selectOneList" @cancel="selectOne_picker = false" @confirm="confirmSelectOne" />
    </van-popup>
    <!-- 省市区 selectLocal -->
    <van-popup v-model="locolSelect_picker" position="bottom">
      <van-area ref="areas" :area-list="locolSelectList" :columns-num="2" @confirm="confirmLocalSelect" />
    </van-popup>
    <!-- 双选下拉 -->
    <van-popup v-model="selectTwo_picker" position="bottom">
      <van-picker show-toolbar :columns="selectTwoList" @cancel="selectTwo_picker = false" @change="selectTwoOnChange" @confirm="confirmSelectTwo" />
    </van-popup>
    <!-- 弹出标签 tips -->
    <van-popup class="explain" v-model="openModul">
      <div>
        <h2>{{ openContent.title }}</h2>
        <div class="pps" v-html="openContent.content"></div>
      </div>
    </van-popup>
	</div>
</template>
<script>
	import { index, subtable, getprofession, getjob, save_user_head, dynamic_data } from '@/api/course'
  import { shareCon } from "@/utils/wxconfig"
  import locolSelectList  from '@/utils/area'
  import wx from "weixin-js-sdk"
  import { queryString } from '@/utils/tools'
  let imgSrc = require('../../../assets/upload_img.png');
	export default {
		data(){
			return {
        imgSrc: imgSrc,
        // 缓存已经选过的一级下拉数据
        cacheSelectApi1: {},            // 选择过的selectOne都加入到这里
        // 上一个双选数据columns
        prevColumns: [],
        // 上一个地址元素
        prevLocalSelect: null,
        // 上一个双选元素 缓存在这
        prevSelectTwoItem: {},
        // 上一个单选元素 缓存在这
        prevSelectOneItem: {},
        //
        selectOneList: [],
        selectTwoList: [],
        // ----------
        isEdit: false,
				body_show: false,
				// 动态任务任务列表
        dynamicData: [],
        // 已经提交的数据 对象形式显示
        submitData: {},
        // 关联的下拉数据
        cacheData: {
          // 一级
          selectOne: {},
          // 二级
          selectTwo: {}
        },
        // 内容弹出框
        openModul: false,
        // 地址弹出框
        locolSelect_picker: false,
        // 单选弹出框
        selectOne_picker: false,
        // 双选弹出框
        selectTwo_picker: false,
        // 关联弹出框
        union_picker: false,
        // 弹出层 内容
        openContent: {
          title: "默认标题",
          content: "默认标签提示内容"
        },
        // 地区选择 json 数据
        locolSelectList,
        // query参数
        objArg: {
          cid: "",
          cpid: ""
        }
			}
		},
		methods: {
      // 开始拷贝元素
      startCopyItem(item){
        let target = JSON.parse(JSON.stringify(item.source));
        item.list.push(target);
      },
      // 单选下拉
      showPickerSelect(item, bool, bools){
        // 单选下拉显示
        this.selectOne_picker = true;
        // 上一个id与当前选择的id
        let sKey = item.selectKey;
        let pKey = this.prevSelectOneItem.selectKey;
        // 上一个type和当前type
        let sType = item.type;
        let pType = this.prevSelectOneItem.type;

        // 是否当前选中的下拉框与上一个一样
        if(sKey == pKey && sType === pType && !bools){
          return
        }
        // 是否是关联下拉类型
        if(bool){

          let isOneType = item.type === 'selectApi1';
          let isTwoType = item.type === 'selectApi2';

          // 是否是一级关联
          if(isOneType){
            this.selectOneList = Object.keys(this.cacheData.selectTwo[sKey]);
          }else if(isTwoType){
            // 去缓存对象里面看本条二级关联数据对应的父级有没有选择内容
            let pid = item.parentID;
            if(!this.cacheSelectApi1[pid]){
              this.$notify('请先选择上一条数据！');
              this.selectOne_picker = false;
              return
            }
            // 对应的父级
            let pChild;
            // 正常流程  获取二级数据
            for(let arg of this.dynamicData){
              if(arg.tid === item.parentID){
                pChild = arg;
                break;
              }
            }

            // 关联父级所选择的内容
            let pVal = pChild.value;
            this.selectOneList = this.cacheData.selectTwo[sKey][pVal];
          }

        }else{
          // 找当前对应的那一项数据   直接下拉类型
          this.selectOneList = this.cacheData.selectOne[sKey];
        }

        // 缓存当前对象
        this.prevSelectOneItem = item;
      },
      // 双选下拉点击确定
      confirmSelectTwo(arr){
        this.prevSelectTwoItem.value = `${arr[0]}/${arr[1]}`;
        this.selectTwo_picker = false;
      },
      // 双选下拉框
      selectTwoOnChange(picker, values){
        picker.setColumnValues(1, this.prevColumns[values[0]]);
      },
      // 双选下拉框展示数据
      showSelectTwoPicker(item, bool){
        // 显示控件
        this.selectTwo_picker = true;
        // 判断本次id与上一次id是否一致
        let sKey = item.selectKey;
        let pKey = this.prevSelectTwoItem.selectKey;
        // 是否当前选中的下拉框与上一个一样
        if(sKey == pKey && !bool){
          return
        }
        // 找缓存中对应的二级数据
        let citys = this.cacheData.selectTwo[sKey];

        let selectKeys = Object.keys(citys);
        let firstVslues = citys[selectKeys[0]];
        this.selectTwoList = [
          {
            values: selectKeys,
            className: 'column1'
          },
          {
            values: firstVslues,
            className: 'column2',
            defaultIndex: 0
          }
        ];
        // 缓存上一个双选数据列表
        this.prevColumns = citys;
        // 缓存一下元素
        this.prevSelectTwoItem = item;
      },
      // 设置单选
      setChunkIndex(item, val){
        item.value = val;
      },
      // 弹出选择 - 单选
      showPicker(select, item){
        this.selectOne_picker = true;
        this.selectItemingle = item;
        this.selectList = select;
      },
      // 关闭单选 - 确定
      confirmSelectOne(value, index){
        // 设置缓存的对象
        this.prevSelectOneItem.value = value;
        // 隐藏picker
        this.selectOne_picker = false;
        // 加入缓存队列
        let isUnion1 = this.prevSelectOneItem.type === 'selectApi1';
        if(isUnion1){
            // 找当前对应的那一项数据   关联下拉类型  如果true，那么一定是selectApi1
            let tid = this.prevSelectOneItem.tid;
            // 把一级的数据缓存到对象里面，待用
            this.cacheSelectApi1[tid] = true;
            // 清空一级选择对应的二级选择里面的值（因为一级选择的值变化，二级必须重新选择）
            (() => {
              for(let arg of this.dynamicData){
                if(arg.type === 'selectApi2' && arg.parentID == tid){
                  arg.value = '';
                }
                if(arg.type === 'copyType'){
                  for(let arg2 of arg.list){
                    for(let arg3 of arg2){
                      if(arg3.type === 'selectApi2' && arg3.parentID == tid){
                        arg3.value = '';
                      }
                    }
                  }
                }
              }
            })();
        }
      },
      // 选择 省市地址 - 显示
      showLocalSelect(item){
        this.locolSelect_picker = true;
        this.prevLocalSelect = item;
      },
      // 选择地区之后
      confirmLocalSelect(arr){
        this.prevLocalSelect.value = `${arr[0].name}/${arr[1].name}`;
        this.locolSelect_picker = false;
      },
      imgSave(item, serverId) {
        let q = this.$route.query;
        save_user_head({
          cid: q.cid,
          server_id: serverId,
          type: 'targetreport'
        })
        .then(data => {
          item.value = data.headimgurl;
          // this.imgDefault = true;
        });
      },
      uploadImgHandle(item) {
        wx.chooseImage({
          count: 1,
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: (res) => {
            // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            wx.uploadImage({
              localId: res.localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: (res) => {
                // this.serverId = res.serverId;
                this.imgSave(item, res.serverId);
              }
            });
          },

        });
      },
      // 提交动态数据
			dynDataSub(){

			},
      // 提交数据前-加工成品数据
			getDynData(){

      },
      // 提交数据之前-验证数据
			testDataCode(){
        let json = {};
        // for(let arg of this.dynamicData){
        //   if(arg.edit &&)
        // }
      },
      // 显示标签弹窗-内容 tips
      showTagModul(bool, content){
        if(bool){
          this.openModul = true;
          this.openContent.content = content;
        }
      },
      // 显示输入组长度
			changeVal(ev, item, maxLen){
				let tarLen = ev.target.value.length;
        if(tarLen > maxLen){
          this.$toast(`最多只能输入 ${tarLen} 个字符./（ㄒöㄒ）/ ~~`);
          item.value = item.value.substring(0, maxLen);
        }
			},
			pullData(){
				let data = {
          "queue":[
              {
                  "type":"taskTitle",
                  "tid":1560347551023,
                  "edit":false,
                  "style":{
                      "color":{
                          "hex":"#333"
                      }
                  },
                  "value":"默认任务标题"
              },
              {
                  "type":"titleType",
                  "tid":1560347553254,
                  "edit":false,
                  "list":[
                      {
                          "value":"第一段文字",
                          "sizeLg":true,
                          "open":false,
                          "style":{
                              "color":{
                                  "hex":"#eb5032"
                              },
                              "underline":"none"
                          },
                          "openContent":""
                      },
                      {
                          "type":"text",
                          "sizeLg":false,
                          "value":"第二段文字",
                          "style":{
                              "color":{
                                  "hex":"#666"
                              },
                              "underline":"none"
                          },
                          "openContent":""
                      },
                      {
                          "type":"text",
                          "sizeLg":false,
                          "value":"文字",
                          "style":{
                              "color":{
                                  "hex":"#666"
                              },
                              "underline":"underline"
                          },
                          "openContent":"这是弹出的内容，很长很长！",
                          "open":true
                      }
                  ]
              },
              {
                  "type":"lineAcross",
                  "tid":1560347615254,
                  "style":{
                      "color":{
                          "hex":"#666"
                      }
                  },
                  "edit":false
              },
              {
                  "type":"routerLink",
                  "value":"链接文字",
                  "edit":false,
                  "style":{
                      "color":{
                          "hex":"#2309CC"
                      },
                      "underline":"underline"
                  },
                  "tid":1560347617884,
                  "link":"https://open.xjy.cn/main/project1_task2_new?cid=5&pid=48&id=130&name=%E8%A1%8C%E4%B8%9A%E8%B0%83%E7%A0%94"
              },
              {
                  "type":"updateImg",
                  "tid":1560347777605,
                  "label": "请上传头像",
                  "style":{
                    "color":{
                      "hex":"#666"
                    }
                  },
                  "edit":true,
                  "value":""
              },
              {
                  "type":"radioBtn",
                  "tid":1560347786973,
                  "value":"",
                  "style":{
                      "color":{
                          "hex":"#eb5032"
                      }
                  },
                  "edit":true,
                  "list":[
                      "按钮1",
                      "按钮2",
                      "按钮3",
                      "按钮4"
                  ]
              },
              {
                  "type":"textInput",
                  "edit":true,
                  "tid":1560347917485,
                  "config":{
                      "maxLength":"20",
                      "placeholder":"请输入内容"
                  },
                  "value":"这是一段默认文字"
              },
              {
                  "type":"textArea",
                  "edit":true,
                  "tid":1560347926420,
                  "config":{
                      "maxLength":200,
                      "placeholder":"请输入内容"
                  },
                  "value":"这是一段默认文字"
              },
              {
                  "type":"selectApi1",
                  "edit":true,
                  "selectKey":1560347996876,
                  "tid":1560348171691,
                  "value":""
              },
              {
                  "type":"copyType",
                  "label": "点击复制一份简历",
                  "style":{
                    "color":{
                      "hex": '#666'
                    }
                  },
                  "edit":true,
                  "source":[
                      {
                          "type":"textArea",
                          "edit":true,
                          "tid":1560349898420,
                          "config":{
                              "maxLength":200,
                              "placeholder":"请输入内容"
                          },
                          "value":"这是一段默认文字"
                      },
                      {
                          "type":"textArea",
                          "edit":true,
                          "tid":1222349898420,
                          "config":{
                              "maxLength":200,
                              "placeholder":"请输入内容"
                          },
                          "value":"这是一段默认文字"
                      },
                      {
                          "type":"textInput",
                          "edit":true,
                          "tid":1560639898420,
                          "config":{
                              "maxLength":200,
                              "placeholder":"请输入内容"
                          },
                          "value":"这是一段默认文字"
                      },
                      {
                          "type":"selectPos",
                          "edit":true,
                          "tid":1560348162019,
                          "value":""
                      },
                      {
                          "type":"selectTwo",
                          "selectKey":1560347996876,
                          "edit":true,
                          "tid":1560348147804,
                          "value":"",
                          "list":[

                          ]
                      },
                      {
                          "type":"selectOne",
                          "edit":true,
                          "label":"默认标题",
                          "tid":1560347986101,
                          "selectKey":1560347937797,
                          "config":{
                              "isBlock":false
                          },
                          "value":"",
                          "list":[

                          ]
                      },
                      {
                          "type":"selectOne",
                          "edit":true,
                          "label":"默认标题",
                          "tid":1560347986631,
                          "selectKey":1560347937797,
                          "config":{
                              "isBlock":false
                          },
                          "value":"",
                          "list":[

                          ]
                      },
                      {
                          "type":"selectApi2",
                          "edit":true,
                          "selectKey":1560347996876,
                          "parentID":1560348171691,
                          "tid":1560348179099,
                          "value":""
                      },
                      {
                          "type":"fillType",
                          "edit":true,
                          "selectKey":"lineInput",
                          "tid":1560347652085,
                          "list":[
                              {
                                  "type":"label",
                                  "value":"请输入出生，年",
                                  "edit":false,
                                  "tid":1560347690070,
                                  "style":{
                                      "color":{
                                          "hex":"#EB5032"
                                      },
                                      "underline":"none"
                                  }
                              },
                              {
                                  "type":"lineInput",
                                  "tid":1560347712364,
                                  "edit":true,
                                  "value":"",
                                  "config":{
                                      "placeholder":"提示信息",
                                      "maxLength":40
                                  }
                              },
                              {
                                  "type":"label",
                                  "value":"月",
                                  "tid":1560347729158,
                                  "edit":false,
                                  "style":{
                                      "color":{
                                          "hex":"#EB5032"
                                      },
                                      "underline":"underline"
                                  }
                              },
                              {
                                  "type":"lineInput",
                                  "tid":1560347740908,
                                  "edit":true,
                                  "value":"",
                                  "config":{
                                      "placeholder":"提示信息",
                                      "maxLength":40
                                  }
                              },
                              {
                                  "type":"label",
                                  "value":"日",
                                  "tid":1560347757548,
                                  "edit":false,
                                  "style":{
                                      "color":{
                                          "hex":"#EB5032"
                                      },
                                      "underline":"underline"
                                  }
                              },
                              {
                                  "type":"frameInput",
                                  "edit":true,
                                  "tid":1560347766366,
                                  "value":"",
                                  "config":{
                                      "placeholder":"提示信息",
                                      "maxLength":40
                                  }
                              }
                          ]
                      }
                  ],
                  "list":[

                  ],
                  "config":{
                      "maxLength":5
                  },
                  "value":[

                  ],
                  "tid":1560348200204
              }
          ],
          "cache":{
              "selectOne":{
                  "1560347937797":[
                      "张三",
                      "李四",
                      "王五",
                      "赵柳",
                      "小七"
                  ]
              },
              "selectTwo":{
                  "1560347996876":{
                      "金融":[
                          "保险",
                          "理财",
                          "银行",
                          "贷款"
                      ],
                      "教育":[
                          "互联网教育",
                          "小学教育",
                          "中学教育",
                          "小学教育",
                          "幼儿园教育",
                          "成人教育"
                      ]
                  }
              }
          },
          "stora":{

          }
        }
        //
        this.dynamicData = data.queue;
        this.submitData = data.stora;
        this.cacheData.selectOne = data.cache.selectOne;
        this.cacheData.selectTwo = data.cache.selectTwo;
        this.body_show = true;
			}
		},
		created(){
			this.pullData();
			shareCon("course",this);
		}
	}
</script>
<style lang="scss" scoped>
  .task_box{
    padding: 20px;
    .row-margin{
      margin-top: 20px;
    }
  }
  /* 项目标题 */
  .task-title{
    text-align: center;
    font-size: .48rem;
    color: #333;
    font-weight: 700;
  }
  /* 链接 */
  .task-link{
    display: block;
    margin-top: .533333rem;
    font-size: .346667rem;
    img{
      width: .373333rem;
      height: .373333rem;
      margin-right: .16rem;
    }
  }
  /* 文字标题 */
  .task_rows{
    line-height: .64rem;
    font-weight: 400;
    .max{
      font-size: .426667rem;
    }
    .min{
      font-size: .426667rem;
    }
  }
  /* 多行输入组 */
  .textArea{
    textarea{
      height: 1.92rem;
      width: 100%;
      color: #333;
      text-align: justify;
      border-radius: .106667rem;
      background: #fff;
      padding: .266667rem;
      border: none;
      font-size: .346667rem;
      resize: none;
      word-wrap: break-word;
      word-break: normal;
    }

  }
  .public-input{
    .tip-num{
      position: absolute;
      right: .133333rem;
      color: #666;
      font-size: .24rem;
      bottom: .133333rem;
      line-height: .4rem;
    }
  }
  /* 单行输入组 */
  .row-input{
    height: .933333rem;
    padding-left: .266667rem;
    background: #fff;
    border-radius: .106667rem;
    overflow-y: hidden;
    input{
      border: none;
      padding: 0;
      margin: 0;
      height: 100%;
      line-height: 100%;
      width: 100%;
      word-wrap: break-word;
      word-break: normal;
    }
  }
  /* 按钮 */
  .row-button{
    button{
      width: 1.466667rem;
      height: .933333rem;
      display: inline-block;
      outline: 0!important;
      background-color: transparent;
      margin-left: .266667rem;
      font-size: .426667rem;
      overflow: hidden;
      border-radius: .106667rem;
    }
  }
  /* 文本带输入 */
  .fill-box{
    // line-height: 1rem;
    >div{
      display: inline-block;
      font-size: .346667rem
    }
    input{
      margin: 0 5px;
    }
    .line-input{
      background: none;
      border: none;
      border-bottom: .013333rem solid #333;
      width: 2.8rem;
      color: #eb5032;
      font-size: .346667rem;
      text-align: center;
      border-radius: 0;
    }
    .frame-input{
      line-height: .933333rem;
      border-radius: .106667rem;
      background: #fff;
      border: none;
      width: 3.386667rem;
      color: #333;
      font-size: .346667rem;
      text-align: left;
      padding: 0 .266667rem;
    }
  }
  /* 图片上传 */
  .upload-img{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    img{
      max-width: 100%;
    }
    >a{
      display: block;
      width: 1.6rem;
      height: 1.6rem;
      background: #fff;
      margin-right: .266667rem;
      overflow: hidden;
    }

  }
  /* 单选 */
  .block{
    display: block;
  }
  .inBlock{
    display: inline-block;
    width: 47%;
    margin-right: 10px;
  }
  /* 提交 */
  .sub_button{
    background-color: #ccc;
    width: 2.32rem;
    height: .88rem;
    line-height: .88rem;
    border-radius: .44rem;
    margin: 1.066667rem auto 1.066667rem;
    font-size: .453333rem;
    border: 0;
    color: #fff;
  }
  .active_btn{
    background: #eb5032;
  }
</style>
<style>
  .task-dynamic-cell-group .van-cell{
    padding: 0;
    background: transparent;
  }
	.task-dynamic-cell-group .van-field__label{
    background: #f0f0f0;
    line-height: 40px;
  }
  .task-dynamic-cell-group .van-cell .van-cell__value input{
    background-color: #fff;
    border: .013333rem solid #ccc;
    font-size: .346667rem;
    margin-top: 0;
    height: .933333rem;
    padding: 0 .266667rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: .106667rem;
  }
  .task-dynamic-cell-group .van-cell .van-field__label{
    line-height: .933333rem;
    font-size: .346667rem;
    max-width: 1.733333rem;
    width: 1.733333rem;
    -webkit-box-flex: 0;
    -webkit-flex: none;
    flex: none;
    padding-right: .266667rem;
    text-align: right;
    color: #666;
  }
  .task-dynamic-cell-group .van-cell .van-cell__value input {
    background-color: #fff;
    border: .013333rem solid #ccc;
    font-size: .346667rem;
    margin-top: 0;
    height: .933333rem;
    padding: 0 .266667rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: .106667rem;
  }
  .task-dynamic-cell-group .choose_lable {
    width: .36rem;
    height: .213333rem;
    background: url(../../../assets/down.png) top no-repeat;
    background-size: cover;
    position: absolute;
    display: inline-block;
    right: .4rem;
    top: .366667rem;
  }
</style>